import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";
import EvaluationRating from "./Components/EvaluationRating";
import { dateFormat, formatString } from "helpers/common";
import ReportFooter from "../Clients/Reports/Components/ReportFooter";

// Create styles
const styles = StyleSheet.create({
  header: {
    alignItems: "center",
    justifyContent: "center"
  },
  logo: {
    width: "20%",
  },
  templateHeading: {
    fontSize: "15px",
    marginBottom: "10px",
  },
  templateContainer: {
    flexDirection: "column",
  },
  templateField: {
    paddingVertical: "10px",
  },
  tableRow: {
    ...globalStyles.tableRow,
    paddingVertical: "10px"
  },
});

const evaluationTitles = {
  showing_enthusiasm_and_attention: "Showing enthusiasm and attention",
  keeping_participants_engaged: "Keeping participants engaged",
  modelling_skills_using_strategies: "Modelling skills & using strategies"
}

export const EvaluationReportPdfDoc = ({ data, userData }) => {
  return (
    <Document>
      <Page size="A4" style={globalStyles.page}>

        {/* Report Header */}
        <View style={[globalStyles.section, styles.header]}>
          <Image
            style={styles.logo}
            src={logo}
          />
          <Text style={globalStyles.reportHeading}>Evaluation Report</Text>
        </View>

        <View style={[globalStyles.section, { alignItems: "center" }]}>
          <View style={{ width: "60%" }}>
            <View style={globalStyles.reportQuestionOuter} wrap={false}>
              <Text style={globalStyles.reportQuestion}>Date</Text>
              <Text>{dateFormat(data?.session_date)}</Text>
            </View>

            {data?.ratings?.length > 0 && data?.ratings.map((rating, index) => (
              <View key={index} style={globalStyles.reportQuestionOuter} wrap={false}>
                <Text style={globalStyles.reportQuestion}>{evaluationTitles[rating.evaluation_type] || ""}</Text>
                <View>
                  <EvaluationRating rating={rating.evaluation_rating} />
                </View>
              </View>
            ))}

            <View style={globalStyles.reportQuestionOuter} wrap={false}>
              <Text style={globalStyles.reportQuestion}>Suggestions</Text>
              <Text>{data?.suggestions}</Text>
            </View>

            <View style={globalStyles.reportQuestionOuter} wrap={false}>
              <Text style={globalStyles.reportQuestion}>Name</Text>
              <Text>{userData?.name}</Text>
            </View>
            
            <View style={globalStyles.reportQuestionOuter} wrap={false}>
              <Text style={globalStyles.reportQuestion}>Email</Text>
              <Text>{userData?.email}</Text>
            </View>
          </View>
        </View>

        <ReportFooter
          data={data}
        />
      </Page>
    </Document>
  )
};
